import { ACCEPTED_UPLOAD_FILE_TYPES } from "../upload/acceptedFileTypes";

// Formats a MIME content type as a short upper-case label, shared by both frontends so file
// metadata displays identically. Known upload types use their registered extension (the Office and
// mail subtypes are unreadable, e.g. "vnd.openxmlformats-officedocument.wordprocessingml.document"
// -> "DOCX"); anything else falls back to the subtype ("application/pdf" -> "PDF").
export function formatContentType(contentType: string): string {
  const extension = ACCEPTED_UPLOAD_FILE_TYPES[contentType.toLowerCase()]?.[0];
  if (extension !== undefined) {
    return extension.replace(".", "").toUpperCase();
  }
  return contentType.split("/").pop()?.toUpperCase() ?? contentType;
}
